import * as React from "react";
import type { SVGProps } from "react";
const SvgCalculator02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m6.375 17.625 11.25-11.25M8.25 10.75v-2.5m0 0v-2.5m0 2.5h-2.5m2.5 0h2.5m2.5 8.125h5M4.703 22h14.594A2.703 2.703 0 0 0 22 19.297V4.703A2.703 2.703 0 0 0 19.297 2H4.703A2.703 2.703 0 0 0 2 4.703v14.594A2.703 2.703 0 0 0 4.703 22"
    />
  </svg>
);
export default SvgCalculator02;
